export class ItemMorosidad {
    acreedor;
    por_vencer;
    no_devenga_intereses;
    vencido;
    saldo_deuda;
    constructor() {
        this.acreedor = "";
        this.por_vencer = "";
        this.no_devenga_intereses = "";
        this.vencido = "";
        this.saldo_deuda = 0;
    }
}
